import { getUrlInfo } from 'utils/helperFunctions';

const { protocol, domain } = getUrlInfo();

export let BACKEND_URL: string | undefined;
export let WEB_EMBED_SCRIPT: string | undefined;

if (process.env.REACT_APP_ENV === 'development') {
  BACKEND_URL = `${protocol}//api-${domain}:3000${process.env.REACT_APP_API_VERSION}`;
  WEB_EMBED_SCRIPT = `${protocol}//localhost:8080/embed.js`;
} else {
  BACKEND_URL = `${protocol}//api-${domain}${process.env.REACT_APP_API_VERSION}`;
  WEB_EMBED_SCRIPT = `${protocol}//voicebot-${domain}/embed.js`;
}
